const basepaths = {
    dev: 'https://api.scisapp.com.dev.fortalsistemas.com.br/v1/dev',
    alpha: 'https://api.scisapp.com.staging.fortalsistemas.com.br/v1/alpha',
    beta: '',
    prod: 'https://api.scisapp.com/v1/prod',
};

const url = basepaths[process.env.REACT_APP_STAGE || 'dev'];

const urlCognito = {
    dev: 'https://dev.api.scisapp.com.dev.fortalsistemas.com.br/dev/me',
    alpha: 'https://alpha.api.scisapp.com.staging.fortalsistemas.com.br/alpha/me',
    beta: '',
    prod: 'https://prod.api.scisapp.com/prod/me',
};

const Cognito = urlCognito[process.env.REACT_APP_STAGE || 'dev'];

const authUrls = {
    dev: 'https://dev.login.scisapp.com/v2/oauth2',
    alpha: 'https://login.febracis.com.br.staging.fortalsistemas.com.br/v2/oauth2',
    beta: '',
    prod: 'https://login.febracis.com.br/v2/oauth2',
};

const newEadUrls = {
    dev: 'https://dev.api.scisapp.com.dev.fortalsistemas.com.br/v2/ead',
    alpha: 'https://alpha.api.scisapp.com.staging.fortalsistemas.com.br/v2/ead',
    beta: '',
    prod: 'https://prod.api.scisapp.com/v2/ead',
};

const redirectNewEad = {
    dev: 'https://online-tests.ead.febracis.com.br.dev.fortalsistemas.com.br/test',
    alpha: 'https://online-tests.ead.febracis.com.br.staging.fortalsistemas.com.br/test',
    beta: '',
    prod: 'https://online-tests.ead.febracis.com.br/test',
};

export const urlRedirectNewEad = redirectNewEad[process.env.REACT_APP_STAGE || 'dev'];

export const urlScisRedirect = 'https://ciseduca.curseduca.pro/login?destinyUrl=%2Fm%2Fcourses';

const urlNewEad = newEadUrls[process.env.REACT_APP_STAGE || 'dev'];

export const urlAuth = authUrls[process.env.REACT_APP_STAGE || 'dev'];

export const urls = {
    LOGIN: urlAuth + '/token',
    LOGOUT: urlAuth + '/logout',
    GET_USER_INFO: url + '/profiles/me',
    GET_USER_INFO_NAME: urlAuth + '/userinfo',
    GET_USER_INFO_COGNITO: `${Cognito}`,
    CLASSES: id => `${url}/ead-classes/classes${id ? `/${id}` : ''}`,
    STUDENT_ENROLLMENTS: `${url}/ead-enrollments/me/enrollments`,
    STUDENT_ENROLLMENT: id => `${url}/ead-enrollments/me/enrollments/${id}`,
    ENROLLMENT_VIDEO: id => `${url}/ead-enrollments/me/enrollments/${id}/videos`,
    ENROLLMENT_ACTIVITY: id => `${url}/ead-enrollments/me/enrollments/${id}/activities`,
    ENROLLMENT_TCC: id => `${url}/ead-enrollments/me/enrollments/${id}/tccs`,
    FILE_UPLOAD: `${url}/upload`,
    DOWNLOAD_ATTACH_POINT: ( classId, fileId ) => `${url}/ead-enrollments/me/enrollments/${classId}/attachments/${fileId}`,
    GET_CLASSES_NEW_EAD : `${urlNewEad}/classes`,
    GET_CLASSE_INFO: (classId) => `${urlNewEad}/tccs/${classId}`,
    INIT_TEST_NEW_EAD: `${urlNewEad}/tests`,
    SUBMIT_TEST: (classId) => `${urlNewEad}/tccs/${classId}/submit`,
};

const clientIds = {
    dev: 'sZETd2dhbqg68WVM',
    alpha: 'nzHJ4U6qXL898xSj',
    beta: '',
    prod: 'vP4XUVMxPDLcfyyN',
};

export const general = {
    client_id: clientIds[process.env.REACT_APP_STAGE || 'dev'],
};

export const mode = {
    isRelease: process.env.NODE_ENV === 'production',
    ALL: false,
};



// WEBPACK FOOTER //
// ./src/settings.js